module.exports = __webpack_public_path__ + "static/img/Josh-Giddey.aaee8b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-Giddey.jpg
// module id = oHKc
// module chunks = 1